import {useState,useEffect} from "react"


export const useLocationHash=(initialvalue)=>{
    const [entryId,setEntryId]=useState(getHashes(initialvalue)[1]);
    useEffect(()=>{
        function onHashChange(){
            const [_,hash,targetId]=getHashes();
            hash&&setEntryId(hash);
            targetId&&setTimeout(()=>{
                const element=document.getElementById(targetId);
                element&&element.scrollIntoView();
            },0);
        }
        window.addEventListener("hashchange",onHashChange);
        return ()=>{
            window.removeEventListener("hashchange",onHashChange);
        }
    },[]);
    return entryId;
}

const getHashes=(initialvalue)=>{
    const locationhash=location.hash.toLowerCase();
    const hashes=locationhash.split("#");
    hashes.shift();
    if(!hashes[1]){hashes[1]=initialvalue};
    return hashes;
}
